export const brandLogos = [
  { name: "Backwoods Cigars", src: "https://customer-assets.emergentagent.com/job_cloud-haven-2/artifacts/dr4a60bp_Backwoods_%28cigar_brand%29_logo.svg" },
  { name: "Colts Tobacco", src: "https://customer-assets.emergentagent.com/job_cloud-haven-2/artifacts/cgx863m7_Colts%20Tobacco.png" },
  { name: "BlackStone Cigars", src: "https://customer-assets.emergentagent.com/job_cloud-haven-2/artifacts/eapfgr11_BlackStone%20Logo.png" },
  { name: "Amaren", src: "https://customer-assets.emergentagent.com/job_cloud-haven-2/artifacts/la2qd8wz_Amaren.jpeg" },
  { name: "Adalya Premium Hookah Tobacco", src: "https://customer-assets.emergentagent.com/job_cloud-haven-2/artifacts/itebcmva_Adaya%20Logo.png" },
  { name: "RAW Rolling Papers", src: "https://customer-assets.emergentagent.com/job_cloud-haven-2/artifacts/87dgjcf6_Raw%20logo.png" }
];

export const navLinks = [
  { label: "Home",     href: "#home" },
  { label: "About",    href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Gallery",  href: "#gallery" },
  { label: "Visit Us", href: "#visit" },
  { label: "Contact",  href: "#contact" }
];

export const products = [
  {
    title: "Vaping",
    image: "https://images.unsplash.com/photo-1764795850216-7bba254f8dcf?w=400&h=300&fit=crop",
    items: ["Disposable vapes", "Refillable devices", "Coils & pods", "Vape juices & e-liquids"]
  },
  {
    title: "E-Liquids",
    image: "https://images.unsplash.com/photo-1583165130737-c956ebac7c41?w=400&h=300&fit=crop",
    items: ["Premium e-liquids", "Various flavors", "Nicotine options", "Top brands"]
  },
  {
    title: "Smoking Accessories",
    image: "https://images.unsplash.com/photo-1598052162797-ba3530cc75b1?w=400&h=300&fit=crop",
    items: ["Rolling papers & filters", "Glass pipes & bongs", "Grinders", "Lighters & torches"]
  },
  {
    title: "Glass & Pipes",
    image: "https://images.unsplash.com/photo-1760134703597-b1af11ecd019?w=400&h=300&fit=crop",
    items: ["Glass pipes", "Water pipes", "Bubblers", "Cleaning supplies"]
  },
  {
    title: "Grinders & Tools",
    image: "https://images.pexels.com/photos/8139194/pexels-photo-8139194.jpeg?w=400&h=300&fit=crop",
    items: ["Premium grinders", "Rolling machines", "Cleaning tools", "Accessories"]
  },
  {
    title: "Lighters & Torches",
    image: "https://images.unsplash.com/photo-1576969500732-12cc9992a5f4?w=400&h=300&fit=crop",
    items: ["Zippo lighters", "Torch lighters", "Disposable lighters", "Butane refills"]
  },
  {
    title: "Cannabis Accessories",
    image: "https://images.unsplash.com/photo-1730266635558-efcb0758e50a?w=400&h=300&fit=crop",
    items: ["Storage containers", "Rolling trays", "Smell-proof bags", "Other accessories"]
  },
  {
    title: "Vape Devices",
    image: "https://images.unsplash.com/photo-1613392083937-f68bcff3bf10?w=400&h=300&fit=crop",
    items: ["Pod systems", "Box mods", "Starter kits", "Advanced devices"]
  }
];

export const galleryImages = [
  { src: "https://images.unsplash.com/photo-1522741070277-b1b2ba3a7bd3?w=500&h=500&fit=crop", alt: "Vaping lifestyle" },
  { src: "https://images.unsplash.com/photo-1553273058-03f8445d9f2e?w=500&h=500&fit=crop",   alt: "Vaping with style" },
  { src: "https://images.unsplash.com/photo-1618588487745-2d46620cabc5?w=500&h=500&fit=crop", alt: "Store interior" },
  { src: "https://images.unsplash.com/photo-1616065787198-a41b9ab94ef2?w=500&h=500&fit=crop", alt: "Vaping products" },
  { src: "https://images.pexels.com/photos/3545426/pexels-photo-3545426.jpeg?w=500&h=500&fit=crop", alt: "Vapour clouds" },
  { src: "https://images.unsplash.com/photo-1498671546682-94a232c26d17?w=500&h=500&fit=crop", alt: "Cannabis products" },
  { src: "https://images.unsplash.com/photo-1612995923001-27d03779d023?w=500&h=500&fit=crop", alt: "Cannabis accessories" },
  { src: "https://images.unsplash.com/photo-1512659348068-1a36e9d2253e?w=500&h=500&fit=crop", alt: "Smoke shop neon" },
  { src: "https://images.unsplash.com/photo-1681857240171-7408cd66c75e?w=500&h=500&fit=crop", alt: "Shop ambiance" }
];

export const features = [
  {
    icon: "Store",
    title: "Wide Product Selection",
    description: "Extensive range of vaping devices, smoking accessories, and cannabis products"
  },
  {
    icon: "Users",
    title: "Friendly Advice",
    description: "Knowledgeable staff ready to help you find the perfect products"
  },
  {
    icon: "MapPin",
    title: "Convenient Location",
    description: "Easy to find at Westgate Shopping Centre in Roodepoort"
  },
  {
    icon: "Clock",
    title: "Open 9am - 9pm Daily",
    description: "Extended hours to serve you every day of the week"
  }
];

export const storeInfo = {
  address: {
    line1: "Shop S0080A, Westgate Shopping Centre",
    line2: "12 Ontdekkers Road",
    line3: "Roodepoort, 1725",
    line4: "South Africa"
  },
  hours: {
    weekday: "Mon-Sat: 8:00 AM - 9:00 PM",
    sunday:  "Sunday: 8:00 AM - 8:00 PM"
  },
  contact: {
    phone:      "076 380 7236",
    phoneLink:  "tel:+27763807236",
    whatsapp:   "https://wa.me/27763807236",
    email:      "info@stayflysmokers.co.za",
    instagram:  "https://www.instagram.com/stayflysmokers_/",
    facebook:   "https://www.facebook.com/StayFlySmokers/",
    directions: "https://www.google.com/maps/search/?api=1&query=Shop+S0080A+Westgate+Shopping+Centre+12+Ontdekkers+Road+Roodepoort+1725"
  }
};
